import * as React from 'react'
import Svg, { Path, Rect, SvgProps } from 'react-native-svg'

export const Upspace = (props: SvgProps) => (
  <Svg viewBox='0 0 17 12' fill='none' {...props}>
    <Path
      d='M8.57931 5.84222C9.55186 5.84222 10.3403 5.05382 10.3403 4.08127C10.3403 3.10872 9.55186 2.32031 8.57931 2.32031C7.60677 2.32031 6.81836 3.10872 6.81836 4.08127C6.81836 5.05382 7.60677 5.84222 8.57931 5.84222Z'
      stroke='currentColor'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <Path
      d='M11.75 10.8203L11.75 10.2514C11.75 8.59459 10.4069 7.25144 8.75 7.25144L8.41057 7.25144C6.75371 7.25144 5.41056 8.59459 5.41056 10.2514L5.41056 10.8203'
      stroke='currentColor'
    />
    <Rect x='0.5' y='0.5' width='16' height='10.5909' rx='0.5' stroke='currentColor' />
  </Svg>
)
